import React from "react";
import { Link, useLocation } from "react-router-dom";

const NotesNav = ({
  notesContents,
  coverColor,
  contentsColor,
  ReportsColor,
  ppeColor,
  AssetRegisterColor,
}) => {
  const location = useLocation();

  const navItems = [
    { to: "/cover", label: "Cover Page", icon: "📄", color: coverColor, section: "afs" },
    { to: "/contents.jsx", label: "AFS Contents", icon: "📋", color: contentsColor, section: "afs" },
    { to: "/report.jsx", label: "Reports", icon: "📊", color: ReportsColor, section: "reports" },
    { to: "/NotesMenu", label: "Notes Added", icon: "📝", color: notesContents, section: "reports" },
    { to: "/notes", label: "PPE Notes", icon: "🏢", color: ppeColor, section: "assets" },
    { to: "/AssetRegister", label: "Asset Register", icon: "📦", color: AssetRegisterColor, section: "assets" },
    { to: "/AuditPortal", label: "Working Papers", icon: "🛡️", color: "#6f42c1", section: "assurance" },
  ];

  const getNavItemStyle = (item) => {
    const isActive = location.pathname === item.to;
    return {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 20px",
      margin: "0 6px",
      borderRadius: "24px",
      color: isActive ? "#fff" : (item.color || "#555"),
      backgroundColor: isActive ? (item.color || "#0d6efd") : "transparent",
      fontWeight: isActive ? "600" : "500",
      fontSize: "14px",
      textDecoration: "none",
      transition: "all 0.2s ease",
      border: isActive ? "none" : "1px solid #e0e0e0",
      boxShadow: isActive ? "0 2px 8px rgba(0,0,0,0.15)" : "none",
      cursor: "pointer",
    };
  };

  const getNavItemHoverStyle = {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        borderBottom: "1px solid #dee2e6",
        padding: "12px 0",
        backdropFilter: "blur(10px)",
      }}
    >
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              border: "2px solid #dee2e6",
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {/* AFS Generation Section */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px", paddingLeft: "12px" }}>
              <span style={{ 
                fontSize: "11px", 
                fontWeight: "700", 
                color: "#6c757d", 
                textTransform: "uppercase", 
                letterSpacing: "1px",
                marginRight: "8px",
                paddingBottom: "2px",
              }}>
                AFS Generation
              </span>
              {navItems.filter(item => item.section === "afs").map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  style={getNavItemStyle(item)}
                  onMouseEnter={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span style={{ fontSize: "16px" }}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>

            {/* Divider */}
            <div style={{ 
              width: "1px", 
              height: "32px", 
              backgroundColor: "#dee2e6", 
              margin: "0 16px" 
            }}></div>

            {/* Assurance Section */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
              <span style={{ 
                fontSize: "11px", 
                fontWeight: "700", 
                color: "#6c757d", 
                textTransform: "uppercase", 
                letterSpacing: "1px",
                marginRight: "8px",
                paddingBottom: "2px",
              }}>
                Assurance
              </span>
              {navItems.filter(item => item.section === "assurance").map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  style={getNavItemStyle(item)}
                  onMouseEnter={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span style={{ fontSize: "16px" }}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>

            {/* Divider */}
            <div style={{ 
              width: "1px", 
              height: "32px", 
              backgroundColor: "#dee2e6", 
              margin: "0 16px" 
            }}></div>

            {/* Reports & Notes Section */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
              <span style={{ 
                fontSize: "11px", 
                fontWeight: "700", 
                color: "#6c757d", 
                textTransform: "uppercase", 
                letterSpacing: "1px",
                marginRight: "8px",
                paddingBottom: "2px",
              }}>
                Reports & Notes
              </span>
              {navItems.filter(item => item.section === "reports").map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  style={getNavItemStyle(item)}
                  onMouseEnter={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span style={{ fontSize: "16px" }}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>

            {/* Divider */}
            <div style={{ 
              width: "1px", 
              height: "32px", 
              backgroundColor: "#dee2e6", 
              margin: "0 16px" 
            }}></div>

            {/* Asset Management Section */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
              <span style={{ 
                fontSize: "11px", 
                fontWeight: "700", 
                color: "#6c757d", 
                textTransform: "uppercase", 
                letterSpacing: "1px",
                marginRight: "8px",
                paddingBottom: "2px",
              }}>
                Asset Management
              </span>
              {navItems.filter(item => item.section === "assets").map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  style={getNavItemStyle(item)}
                  onMouseEnter={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== item.to) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span style={{ fontSize: "16px" }}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NotesNav;
